import api from '@app/api'

import type { GetCompetitorsParams } from './types'
import type { CompetitorsDto } from './dtos'
import type { AblePaginatedResponseFn } from '@app/api/dtos'

const URL = '/location/competitors/'

export const getCompetitors: AblePaginatedResponseFn<GetCompetitorsParams, CompetitorsDto> = async params => {
  const response = await api.get(URL, { params })
  return response.data
}
